/**
 * NOTE: CODEGEN IS USED IN THIS FILE. Careless manual edits may be lost.
 *
 * server/tools/syncDirs.ts keeps this file in sync with:
 *   server/src/shared/legacyTypes/fetchClassesTypes.ts
 */

import {Type, Static} from "@sinclair/typebox";
import {Nullable} from "../Types";

export const dayOfWeekT = Type.Union([
	Type.Literal("monday"),
	Type.Literal("tuesday"),
	Type.Literal("wednesday"),
	Type.Literal("thursday"),
	Type.Literal("friday"),
	Type.Literal("saturday"),
	Type.Literal("sunday"),
]);

export type DayOfWeek = Static<typeof dayOfWeekT>;

export const DAY_OF_WEEK_MAP = {
	MONDAY: "monday",
	TUESDAY: "tuesday",
	WEDNESDAY: "wednesday",
	THURSDAY: "thursday",
	FRIDAY: "friday",
	SATURDAY: "saturday",
	SUNDAY: "sunday",
} as const satisfies Record<string, DayOfWeek>;

export const enrollStatusT = Type.Union([
	Type.Literal("open"),
	Type.Literal("closed"),
	Type.Literal("full"),
	Type.Literal("waitlist"),
]);

export type EnrollStatus = Static<typeof enrollStatusT>;

export const ENROLL_STATUS_MAP = {
	OPEN: "open",
	CLOSED: "closed",
	FULL: "full",
	WAITLIST: "waitlist",
} as const satisfies Record<string, EnrollStatus>;

export const legacyDateT = Type.Object({
	date: Type.String(),
	timezone_type: Type.Number(),
	timezone: Type.String(),
});

export const legacyClassT = Type.Object({
	class_id: Type.String(),
	course_id: Type.String(),
	name: Type.String(),
	instructor_user_id: Type.String(),
	instructor_platform_id: Nullable(Type.String()),
	open_spots: Type.String(),
	is_visible: Type.String(),
	student_enrollment: Type.String(),
	schedule: Type.String(),
	max_enrollment: Type.String(),
	cost: Type.String(),
	classroom_id: Type.String(),
	waitlisted: Type.String(),
	season_id: Type.String(),
	date_start_at: Type.String(),
	time_start_at: Type.String(),
	campus_id: Type.String(),
	is_active: Type.String(),
	teacher: Nullable(Type.String()),
	register_deadline_at: Type.String(),
	is_pipeline: Type.String(),
	is_exact: Type.String(),
	lumen: Nullable(Type.String()),
	invited: Type.String(),
	is_stretch: Type.String(),
	is_closed: Type.String(),
	date_end_at: Type.String(),
	time_end_at: Type.String(),
	book_bundle_id: Nullable(Type.String()),
	ebook_sku: Type.String(),
	dow: Type.Array(dayOfWeekT),
	start: legacyDateT,
	end: legacyDateT,
	start_in_campus_timezone: legacyDateT,
	end_in_campus_timezone: legacyDateT,
	is_summer: Type.Boolean(),
	enroll_status: enrollStatusT,
});

export const bookT = Type.Object({
	sku: Type.String(),
	name: Type.String(),
});

export const fetchClassesForCourseByCampusIdResponseT = Type.Object({
	classes: Type.Record(Type.String(), Type.Array(legacyClassT)),
	timestamp: Type.String(),
	success: Type.Boolean(),
});

export type LegacyDate = Static<typeof legacyDateT>;
export type LegacyClass = Static<typeof legacyClassT>;
export type Book = Static<typeof bookT>;
export type FetchClassesForCourseByCampusIdResponse = Static<
	typeof fetchClassesForCourseByCampusIdResponseT
>;
